import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class RoadmapTableTableCellToggleInitiativeIndexComponent extends Component {
  @action
  handleChange(e) {
    this.args.params.onChange(e.target.checked);
  }
}
